import { TYPE_INSTAGRAM_STORY } from '../../constants/networks';

export const getThumbnail = (task, content) => {
    if (task.value?.type === TYPE_INSTAGRAM_STORY) {
        return content?.media_library_content?.thumbnail || content?.content?.url || null;
    }
    return content?.media_library_content?.thumbnail;
};
